import dialogs from './registered-dialogs';

const registerDialog = (modalType, Component, options = {}) => {
  dialogs.set(modalType, { Component, options });
};

export default registerDialog;
